import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import {
  BooksHeaderLink,
  BooksHeaderWrapper,
} from "../../../Books/components/BooksHeader/BooksHeader.styles";

const ShopifyHeader: FC = () => {
  const { t } = useTranslation("common");
  return (
    <BooksHeaderWrapper>
      <BooksHeaderLink title={t("shopify.items")} end to="/shopify">
        {t("shopify.items")}
      </BooksHeaderLink>
      <BooksHeaderLink
        title={t("shopify.profiles")}
        end
        to="/shopify/profiles"
      >
        {t("shopify.profiles")}
      </BooksHeaderLink>
    </BooksHeaderWrapper>
  );
};

export default memo(ShopifyHeader);
